import {useState} from "react";
import {LeadTabs} from "./Tabs";

export const MobileView = () => {
    const [search, setSearch] = useState("");
    return (
        <div className="w-full p-6">
            <div className="flex justify-between items-center">
                <h3 className="text-lg font-semibold text-gray-900">Manage Leads</h3>
            </div>

            <LeadTabs search={search} setSearch={setSearch}/>
        </div>
    );
};
